const carouselItems = [
  {
    title: '2025暑期档必看片单',
    desc: '暑假来临，我们为你整理了今年最值得期待的暑期档影视作品，从国产大片到海外巨制，让你的夏天精彩不停。',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marathon%20theme%20with%20warm%20golden%20sunset%20light%2C%20film%20poster%20collage%20aesthetic%20with%20rich%20amber%20and%20coral%20tones%2C%20dramatic%20theater%20atmosphere%20with%20soft%20bokeh%2C%20entertainment%20and%20excitement%20vibe%2C%20clean%20dark%20background%20with%20warm%20highlights&width=1200&height=600&seq=carousel-1-51video&orientation=landscape',
  },
  {
    title: '国剧崛起：年度十佳国产剧',
    desc: '过去一年国产剧集质量大幅提升，从悬疑到古装，从都市到科幻，我们评选出了年度十佳佳作，每一部都值得二刷。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20costume%20drama%20and%20modern%20drama%20fusion%20visual%2C%20warm%20cinematic%20lighting%20with%20rich%20crimson%20and%20gold%20accents%2C%20premium%20TV%20series%20collection%20aesthetic%2C%20sophisticated%20entertainment%20presentation%2C%20clean%20dark%20backdrop%20with%20dramatic%20atmosphere&width=1200&height=600&seq=carousel-2-51video&orientation=landscape',
  },
  {
    title: '韩剧迷的狂欢：高分韩剧合集',
    desc: '从浪漫爱情到悬疑惊悚，从古装史剧到现实题材，这些韩剧在豆瓣评分均超过8.5，是韩剧爱好者不可错过的经典。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20aesthetic%20with%20warm%20soft%20lighting%20and%20pastel%20tones%2C%20emotional%20and%20artistic%20cinematography%20style%2C%20cherry%20blossom%20and%20urban%20night%20scenes%20blend%2C%20clean%20dreamy%20background%20with%20golden%20hour%20glow&width=1200&height=600&seq=carousel-3-51video&orientation=landscape',
  },
  {
    title: '动漫迷福音：新番导视',
    desc: '本季新番精彩纷呈，热血、搞笑、治愈一应俱全。无论你是资深二次元还是刚入坑，这份导视都能帮你找到心仪的番剧。',
    tag: '新番推荐',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20art%20style%20collage%20with%20warm%20and%20colorful%20illustration%20aesthetic%2C%20dynamic%20Japanese%20animation%20visuals%20with%20golden%20light%20effects%2C%20exciting%20and%20energetic%20atmosphere%2C%20clean%20artistic%20background%20with%20soft%20gradients&width=1200&height=600&seq=carousel-4-51video&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">深度策划的影视专题内容，带你发现更多好片</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block text-xs px-2 py-0.5 rounded bg-accent-500 text-white font-medium mb-2 whitespace-nowrap">{item.tag}</span>
                <h3 className="text-base md:text-lg font-bold text-white mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-white/75 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}